module.exports = "static/assets/b1f026ce265c0f666e2063ef94b06109.svg";